import classNames from 'classnames'
import { Text } from 'components/Text'
import { LabelProps } from './Form'

export function Label({ className, children, style }: LabelProps) {
  return (
    <Text.Detail
      className={classNames(className, 'margin-vertical-8')}
      style={style}
    >
      {children}
    </Text.Detail>
  )
}
